<template>
  <div style="padding: 20px; height: 100vh; overflow:auto">
    <div v-html="promotion">
    </div>
  </div>

</template>

<script>
export default {
  name: 'BuyPromotion',
  data () {
    return {
      promotion: {}
    }
  },
  mounted () {
    this.gcapi('getPurchaseAgreement').then((res) => {
      console.log(res)
      if (res.body.code === 0) {
        this.promotion = res.body.result
      }
    })
  },
  methods: {}
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// BuyPromotion.vue?94e1e206